document.addEventListener('DOMContentLoaded', function() {
  if (window.jQuery && $('.image-carousel.owl-carousel').length) {
    $('.image-carousel.owl-carousel').owlCarousel({
      loop: true,
      margin: 10,
      nav: false,
      dots: true,
      autoplay: false,
      autoplayTimeout: 3000,
      autoplayHoverPause: true,
      responsive: {
        0: { items: 1 },
        768: { items: 2 },
        1024: { items: 2 }
      }
    });
  } 

const dateSpan = document.querySelector('#delivery-date .date');
    const today = new Date();
    today.setDate(today.getDate() + 7);
    const options = { month: 'short', day: 'numeric' };
    const deliveryDate = today.toLocaleDateString('en-US', options);
    dateSpan.textContent = deliveryDate;
}); 
